var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpandMore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_528_24748",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 24,
    width: 24,
    height: 24,
    transform: "rotate(-90 0 24)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_528_24748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9498 12C14.9498 12.1333 14.9289 12.2583 14.8873 12.375C14.8456 12.4916 14.7748 12.6 14.6748 12.7L10.0498 17.325C9.86643 17.5083 9.63726 17.5958 9.36226 17.5875C9.08726 17.5791 8.8581 17.4833 8.67476 17.3C8.49143 17.1166 8.39976 16.8833 8.39976 16.6C8.39976 16.3166 8.49143 16.0833 8.67476 15.9L12.5748 12L8.64976 8.07497C8.46643 7.89164 8.37893 7.66247 8.38726 7.38747C8.3956 7.11247 8.49143 6.8833 8.67476 6.69997C8.8581 6.51664 9.09143 6.42497 9.37476 6.42497C9.6581 6.42497 9.89143 6.51664 10.0748 6.69997L14.6748 11.3C14.7748 11.4 14.8456 11.5083 14.8873 11.625C14.9289 11.7416 14.9498 11.8666 14.9498 12Z",
    fill: "black",
    fillOpacity: 0.7
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandMore);
export default __webpack_public_path__ + "static/media/expand_more.6f2c72550803dc75fc652c790f5f5036.svg";
export { ForwardRef as ReactComponent };